import { z } from "zod/v4";
import { parseAmountInput } from "@/lib/amountInput";
import { TPAYGATE_ENVIRONMENTS } from "@/types/tpaygate";

export const tPaygateConfigSchema = z.object({
  configId: z.string().optional().or(z.literal("")),
  clientId: z.string().min(1, "Client ID is required"),
  tPayGateTenantId: z.string().min(1, "T-PayGate Tenant ID is required"),
  source: z.string().min(1, "Source is required"),
  environment: z.enum(TPAYGATE_ENVIRONMENTS),
  webhookUrl: z
    .string()
    .url("Must be a valid HTTPS URL")
    .optional()
    .or(z.literal("")),
  clientSecret: z.string().optional().or(z.literal("")),
  isActive: z.boolean(),
});

export type TPaygateConfigForm = z.infer<typeof tPaygateConfigSchema>;

export const connectBankSchema = z.object({
  bankCode: z.string().min(1, "Bank is required"),
  merchantName: z.string().min(1, "Merchant name is required"),
  accountName: z.string().min(1, "Account name is required"),
  accountNo: z.string().min(1, "Account number is required"),
  identity: z.string().optional(),
  phone: z.string().optional(),
  email: z.string().email("Must be a valid email").optional().or(z.literal("")),
  prefix: z.string().optional(),
  clientId: z.string().optional(),
  encryptKey: z.string().optional(),
  secretKey: z.string().optional(),
});

export type ConnectBankForm = z.infer<typeof connectBankSchema>;

export const otpSchema = z.object({
  otpNumber: z
    .string()
    .length(6, "OTP must be 6 digits")
    .regex(/^\d+$/, "OTP must contain digits only"),
});

export type OtpForm = z.infer<typeof otpSchema>;

/** The simulated callback. `amount` holds the grouped text of the field, not a number. */
export const webhookSimulationSchema = z.object({
  refTransactionId: z
    .string()
    .trim()
    .min(1, "Payment code is required")
    .max(100, "Payment code is too long"),
  billCode: z
    .string()
    .trim()
    .min(1, "Bill code is required")
    .max(100, "Bill code is too long"),
  amount: z
    .string()
    .refine(
      (value) => (parseAmountInput(value) ?? 0) > 0,
      "Amount must be greater than zero",
    ),
  virtualAccount: z.string().max(100, "Virtual account is too long"),
  actualAccount: z.string().max(100, "Actual account is too long"),
  paymentTime: z.string(),
});

export type WebhookSimulationForm = z.infer<typeof webhookSimulationSchema>;
